import { render } from "./Deduction.vue?vue&type=template&id=9f3591ee"
import script from "./Deduction.vue?vue&type=script&lang=js"
export * from "./Deduction.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__